//Types
export const Types = {
  CREATE_PIPELINE: "CREATE_PIPELINE",
  UPDATE_PIPELINE: "UPDATE_PIPELINE",
  GET_PIPELINE: "GET_PIPELINE",
  GET_ALL_PIPELINES: "GET_ALL_PIPELINES",
  DELETE_PIPELINE: "DELETE_PIPELINE",
  SET_LOADING: "SET_LOADING_PIPELINE",
  CLEAR_PIPELINES_REGISTER: "CLEAR_PIPELINES_REGISTER",
  SAVE_PIPELINE_CREATION: "SAVE_PIPELINE_CREATION",
  ADD_NEW_PIPELINE_EXECUTION: "ADD_NEW_PIPELINE_EXECUTION",
  GET_JUPYTERHUB_FILE_SYSTEM: "GET_JUPYTERHUB_FILE_SYSTEM",
  GET_COLLECTIONS_LOGS: "GET_COLLECTIONS_LOGS",
  GET_COLLECTION_LOGS: "GET_COLLECTION_LOGS",
  GET_PIPELINES_LOGS: "GET_PIPELINES_LOGS",
  GET_EXECUTION_LOGS: "GET_EXECUTION_LOGS"
};

//Reducer
const initialState = {
  pipelines: null,
  pipeline: null,
  jupyterhubFileSystem: {},
  loading: false,
  collectionsLogs: null,
  collectionLogs: null,
  pipelinesLogs: null,
  executionLogs: null
};

const Pipelines = (state = initialState, action) => {
  switch (action.type) {
    case Types.CREATE_PIPELINE:
      return {
        ...state,
      };

    case Types.UPDATE_PIPELINE:
      return {
        ...state,
        pipeline: action.payload,
        loading: false,
      };

    case Types.GET_COLLECTIONS_LOGS:
      return {
        ...state,
        collectionsLogs: action.payload,
        loading: false,
      };

    case Types.GET_COLLECTION_LOGS:
      return {
        ...state,
        collectionLogs: action.payload,
        loading: false,
      };

    case Types.GET_PIPELINES_LOGS:
      return {
        ...state,
        pipelinesLogs: action.payload,
        loading: false,
      };

    case Types.GET_EXECUTION_LOGS:
      return {
        ...state,
        executionLogs: action.payload,
        loading: false,
      };
      
    case Types.GET_PIPELINE:
      return {
        ...state,
        pipeline: action.payload,
        loading: false,
      };

    case Types.GET_ALL_PIPELINES:
      return {
        ...state,
        pipelines: action.payload,
        loading: false,
      };

    case Types.DELETE_PIPELINE:
      return {
        ...state,
        pipelines: action.payload,
        loading: false,
      };

    case Types.CLEAR_PIPELINES_REGISTER:
      return initialState;

    case Types.SAVE_PIPELINE_CREATION:
      return {
        ...state,
        pipelines: action.payload,
      };

    case Types.SET_LOADING:
      return {
        ...state,
        loading: true,
      };

    case Types.ADD_NEW_PIPELINE_EXECUTION:
      return {
        ...state,
        loading: false,
      };

    case Types.ADD_NEW_PIPELINE_TRUNCATE:
      return {
        ...state,
        loading: false,
      };

    case Types.GET_JUPYTERHUB_FILE_SYSTEM:
      const newFileSystem = {
        ...state.jupyterhubFileSystem,
        ...(action.payload?.reduce((acc, curr) => {
          acc[curr.path] = curr;
          return acc;
        }, {}) || {}),
      };
      Object.keys(newFileSystem).forEach(key => {
        const isKeySubdirectory = action.directory === key.slice(0, action.directory.length);
        const pathNotExists = !action.payload.find(item => item.path === key);
        if (isKeySubdirectory && pathNotExists) {
          delete newFileSystem[key];
        }
      });
      return {
        ...state,
        jupyterhubFileSystem: newFileSystem,
        loading: false,
      }

    default:
      return state;
  }
};

export default Pipelines;
